import {
  addClass,
  removeClass,
  toggleClass,
  getTallestElement,
  matchHeight,
  shrinkAccordionItems,
  toggleFloatPanels,
  toggleAccordionItem,
} from './common-functions';
import { debounce } from 'lodash';

const { feWp } = window;
const { applyFilters } = feWp.hooks;

const constants = require('@constants');
const defaultCssClass = constants.DEFAULT_CSS_CLASS.ACCORDION;
const clzFloatItemsWrapper = `.${defaultCssClass}__flt-itms-wrpr`;
const clzFloatItemWrapper = `.${defaultCssClass}__flt-itm-wrpr`;
const clzFloatItem = `.${defaultCssClass}__flt-itm`;
const clzItems = `.${defaultCssClass}__itm-wrpr`;
const clzItemBody = `.${defaultCssClass}__itm-bdy`;
const activeClass = 'active';
const initClass = 'initialized';

export const appendPanel = (
  acc,
  items,
  floatPanelsWrapper,
  floatPannels,
  settings,
  mobileView,
) => {
  const { autoSlide } = settings;

  if (mobileView) {
    items.forEach((el) => {
      floatPannels.forEach((flEl) => {
        const id = flEl.dataset.id;
        if (
          el.querySelector('[data-toggle="collapse"]').dataset.target === id
        ) {
          el.querySelector(clzItemBody).after(flEl);
          removeClass(acc, 'column');
          if (autoSlide) removeClass(acc, 'auto-slide');
        }
      });
    });
  } else {
    floatPannels.forEach((flEl) => {
      floatPanelsWrapper.appendChild(flEl);
      addClass(acc, 'column');
      if (autoSlide) addClass(acc, 'auto-slide');
    });
  }
};

const floatPanelWrapperSetHeight = (floatPanelsWrapper, floatPannelInner) => {
  const height = getTallestElement(floatPannelInner);
  floatPanelsWrapper.style.minHeight = height + 'px';
};

export const toggleAccordion = (handles, settings, floatPannels, items) => {
  const { toggleMode, floatPanel } = settings;

  handles.forEach((handle) => {
    handle.addEventListener('click', (el) => {
      const id = el.currentTarget.dataset.target;
      const filterActiveItems = items.filter(
        (i) => i.classList.contains(activeClass) && i.dataset.itemId !== id,
      );
      if (toggleMode) {
        shrinkAccordionItems(filterActiveItems);
      }
      toggleAccordionItem(id);
      if (floatPanel) {
        toggleFloatPanels(floatPannels, id);
      }
    });
  });
};

export const autoPlayAccordion = (
  accordions,
  settings,
  slides,
  handles,
  items,
) => {
  const { autoPlayInterval = 3000, colBreakPoint, pauseOnFocus } = settings;
  const activeSlide = slides.filter((f) => f.classList.contains(activeClass));

  const slidesCount = slides.length;
  const activeSlideIndex = slides.findIndex(
    (item) => item.dataset.id === activeSlide[0].dataset.id,
  );

  let set;
  let count = activeSlideIndex;
  let areaFocus = false;
  let onClickAutoPlayPause = false;

  const disableAutoPlayMobile = () => {
    return window.matchMedia(`(max-width: ${colBreakPoint}px)`).matches;
  };

  const fadeIn = (el) => {
    el.style.opacity = '1';
    addClass(el);
  };

  const fadeOut = (el) => {
    el.style.opacity = '0';
    removeClass(el);
  };

  const toggleHandleClass = (id) => {
    for (const element of items) {
      removeClass(element);
    }

    const accordionItemWrapper = document.querySelector(
      `[data-item-id="${id}"`,
    );
    toggleClass(accordionItemWrapper);
  };

  const initialize = () => {
    if (!disableAutoPlayMobile()) {
      set = setInterval(next, autoPlayInterval);
    }
  };

  const next = () => {
    clearInterval(set);
    fadeOut(slides[count]);
    toggleHandleClass(slides[count].dataset.id);
    count = (count + 1) % slidesCount;
    fadeIn(slides[count]);
    toggleHandleClass(slides[count].dataset.id);
    initialize();
  };

  const onClickChange = (onChangeId) => {
    if (disableAutoPlayMobile()) return;
    clearInterval(set);
    count = slides.findIndex((id) => id.dataset.id === onChangeId);
    slides.forEach(fadeOut);
    fadeIn(slides[count]);
    toggleHandleClass(onChangeId);
    if (!areaFocus) {
      initialize();
    }
  };

  if (pauseOnFocus) {
    accordions.addEventListener('mouseenter', () => {
      clearInterval(set);
      areaFocus = true;
    });

    accordions.addEventListener('mouseleave', () => {
      if (onClickAutoPlayPause) return;
      initialize();
      areaFocus = false;
    });
  }

  initialize();

  handles.forEach((handle) => {
    handle.addEventListener('click', () => {
      onClickChange(handle.dataset.target);
      if (autoPlayInterval) {
        onClickAutoPlayPause = true;
        areaFocus = onClickAutoPlayPause;
      }
    });
  });
};

const setMatchHeight = (acc) => {
  matchHeight(acc.querySelectorAll(clzItemBody));
};

const extractAccordions = () => {
  const accordions = document.querySelectorAll('[data-accordion]');
  if (accordions.length <= 0) return;

  accordions.forEach((acc) => {
    if (acc.classList.contains(initClass)) return;
    acc.classList.add(initClass);

    const settings = JSON.parse(acc.dataset.settings);
    const items = Array.from(acc.querySelectorAll(clzItems));
    const floatPanelsWrapper = acc.querySelector(clzFloatItemsWrapper);
    const floatPannels = Array.from(acc.querySelectorAll(clzFloatItemWrapper));
    const floatPannelInner = Array.from(acc.querySelectorAll(clzFloatItem));
    const handles = Array.from(acc.querySelectorAll('[data-target]'));
    const mobileView = window.matchMedia(
      `(max-width: ${settings.colBreakPoint}px)`,
    ).matches;
    if (settings.floatPanel) {
      appendPanel(
        acc,
        items,
        floatPanelsWrapper,
        floatPannels,
        settings,
        mobileView,
      );
      floatPanelWrapperSetHeight(floatPanelsWrapper, floatPannelInner);
    }
    if (settings.autoSlide && !mobileView) {
      autoPlayAccordion(acc, settings, floatPannels, handles, items);
    } else {
      toggleAccordion(handles, settings, floatPannels, items);
    }
    setMatchHeight(acc);
  });
};

let currentWidth = window.innerWidth;
const init = applyFilters('b3rg_accordion_filter', () => {
  const debounceSetTab = debounce(() => {
    if (window.innerWidth !== currentWidth) {
      currentWidth = window.innerWidth;
      extractAccordions();
    }
  }, 600);

  window.addEventListener('load', () => {
    extractAccordions();
    window.addEventListener('resize', debounceSetTab);
  });
});

if (typeof init === 'function') {
  init();
}
